import script from "./MapaComponente.vue?vue&type=script&setup=true&lang=js"
export * from "./MapaComponente.vue?vue&type=script&setup=true&lang=js"

import "./MapaComponente.vue?vue&type=style&index=0&id=d5466164&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5466164"]])

export default __exports__